import * as Yup from "yup";

export const QualificationSchema = Yup.object().shape({
  name: Yup.string().required("Qualification name is required"),
  code: Yup.string().required("Qualification code is required"),
  status: Yup.boolean().required("Qualification status is required"),
});
